// extracted by mini-css-extract-plugin
export var acitonButtons = "_bw-0";
export var additionalIcon = "_bw-f";
export var block = "_bw-1";
export var blockContent = "_bw-7";
export var blockDescription = "_bw-8";
export var blockIcon = "_bw-9";
export var blockTitle = "_bw-6";
export var border = "_bw-a";
export var center = "_bw-l";
export var edge = "_bw-b";
export var edgeLabel = "_bw-c";
export var edgePath = "_bw-d";
export var error = "_bw-e";
export var flowchart = "_bw-g";
export var flowchartContent = "_bw-h";
export var highlighted = "_bw-3";
export var hover = "_bw-4";
export var icon = "_bw-i";
export var left = "_bw-m";
export var navButton = "_bw-j";
export var navButtons = "_bw-k";
export var right = "_bw-n";
export var selected = "_bw-2";
export var small = "_bw-5";